import { render, staticRenderFns } from "./learning.vue?vue&type=template&id=99b6648a"
import script from "./learning.vue?vue&type=script&lang=js"
export * from "./learning.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports